export default function isAchDirectWithdraw(paymentMethodId) {
  return /^airtm:bank:(usa:|puerto-rico-)direct-withdraw$/.test(paymentMethodId);
}
